// ==========================================================================
// Modal Module
// ==========================================================================

export default class Modal {
	constructor(modalId) {
		this.modal = document.getElementById(modalId);
		if (!this.modal) return;

		this.backdrop = this.modal.querySelector('.modal__backdrop');
		this.closeBtn = this.modal.querySelector('.modal__close');

		this.init();
	}

	init() {
		// Close on backdrop click
		if (this.backdrop) {
			this.backdrop.addEventListener('click', () => this.close());
		}

		// Close on close button click
		if (this.closeBtn) {
			this.closeBtn.addEventListener('click', () => this.close());
		}

		// Close on ESC key
		document.addEventListener('keydown', (e) => {
			if (e.key === 'Escape' && this.modal.classList.contains('is-active')) {
				this.close();
			}
		});
	}

	open() {
		// モーダルのスクロール位置を最上部にリセット
		const container = this.modal.querySelector('.modal__container');
		if (container) {
			container.scrollTop = 0;
		}

		this.modal.classList.add('is-active');
		document.body.style.overflow = 'hidden';
	}

	close() {
		this.modal.classList.remove('is-active');
		document.body.style.overflow = '';
	}
}

// Initialize all modals
document.querySelectorAll('.modal').forEach(modal => {
	new Modal(modal.id);
});

// Open modal triggers
document.querySelectorAll('[data-modal]').forEach(trigger => {
	trigger.addEventListener('click', (e) => {
		e.preventDefault();
		const modalId = trigger.getAttribute('data-modal');
		const modal = document.getElementById(modalId);
		if (modal) {
			const modalInstance = new Modal(modalId);
			modalInstance.open();
		}
	});
});
